import { render, staticRenderFns } from "./cTableStyle.vue?vue&type=template&id=5016c4b7&scoped=true&"
import script from "./cTableStyle.vue?vue&type=script&lang=js&"
export * from "./cTableStyle.vue?vue&type=script&lang=js&"
import style0 from "./cTableStyle.vue?vue&type=style&index=0&id=5016c4b7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5016c4b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5016c4b7')) {
      api.createRecord('5016c4b7', component.options)
    } else {
      api.reload('5016c4b7', component.options)
    }
    module.hot.accept("./cTableStyle.vue?vue&type=template&id=5016c4b7&scoped=true&", function () {
      api.rerender('5016c4b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/styleComp/cTableStyle.vue"
export default component.exports